export default __webpack_public_path__ + "static/logo-aaa54d4ee0c361f00797127edc537f64.svg";